import { PropsWithChildren, ReactElement } from "react";
import styles from "./ContentLayout.module.less";
import { localize } from "client_legacy/ndaw/culture";
import {
	Button,
	Icon,
	IconValue,
	Space
} from "client/Components";
import { useCallbackWithoutArguments } from "client/Hooks";

export type ContentLayoutProps = {
	title: string;
	titleIcon?: IconValue;
	explanation?: string | ReactElement;
};

export const ContentLayout = (props: PropsWithChildren<ContentLayoutProps>): ReactElement => {
	const {
		title,
		titleIcon,
		explanation,
		children
	} = props;

	return (
		<>
			<h2 className={styles.title}>
				{title}

				{titleIcon && (
					<>
						<Space />
						<Icon value={titleIcon} />
					</>
				)}
			</h2>

			{explanation && (
				<div className={styles.explanation}>
					{explanation}
				</div>
			)}

			{children}
		</>
	);
};
ContentLayout.displayName = "ContentLayout";

type ContentLayoutButtonsProps = {
	onContinue(): void;
	onSkip?(): void;
	primaryButtonText?: string;
};

const ContentLayoutButtons = (props: ContentLayoutButtonsProps): ReactElement => {
	const {
		primaryButtonText = localize("_Continue"),
		onContinue: onContinueFromProps,
		onSkip: onSkipFromProps
	} = props;

	const onContinue: () => void = useCallbackWithoutArguments(onContinueFromProps);
	const onSkip: (() => void) | undefined = useCallbackWithoutArguments(onSkipFromProps);

	return (
		<div className={styles.buttonContainer}>
			<Button
				kind="primary"
				width="fill"
				text={primaryButtonText}
				onClick={onContinue}
				trackingId="continue"
				size="large"
			/>
			{onSkip && (
				<div className={styles.skipButton}>
					<Button
						kind="transparent"
						width="fill"
						text={localize("_SkipForNow")}
						onClick={onSkip}
						trackingId="skip"
						size="large"
					/>
				</div>
			)}
		</div>
	);
};
ContentLayoutButtons.DisplayName = "ContentLayout.Buttons";

ContentLayout.Buttons = ContentLayoutButtons;